<script setup>
import { computed, ref, watchEffect } from 'vue';
let props = defineProps({
	isSearching: {
		type: Boolean,
		default: false
	},
	data: {
		type: [Object, null],
		required: true,
		default: {}
	},
	suggestions: {
		type: [Array, null],
		required: false,
		default: []
	}
});

const DEFAULT_GROUP = 'Pages';

let rows = computed(() => {
	let documents = props.data?.TypedDocuments ?? [];

	return documents
		.sort((a, b) => a.Score < b.Score)
		.map((document) => ({
			id: JSON.stringify(document.Fields.Id.Value),
			score: document.Score,
			url: document.Fields.Url.Value,
			title: document.Fields.Title.Value,
			description: document.Fields?.MetaDescription?.Value ?? '',
			image: document.Fields?.Image?.Value ?? ''
		}));
});

const banners = computed(() => props.data?.Banners);

const resultCount = computed(() => props?.data?.TotalDocument);

const emit = defineEmits(['suggestion-clicked']);

function onSuggestionClicked(event, item) {
	emit('suggestion-clicked', item);
}
</script>

<template>
	<div class="search-full">
		<div v-if="suggestions?.length" class="search-full__item">
			<h2 class="search-full__item-title">Search Suggestions</h2>
			<ul class="search-full__suggestions-list">
				<li class="search-full__suggestions-list-item" v-for="item in suggestions">
					<button
						class="search-full__suggestions-list-btn"
						type="button"
						v-text="item"
						@click="(event) => onSuggestionClicked(event, item)"
					></button>
				</li>
			</ul>
		</div>

		<div class="search-full__item" v-if="banners" v-for="banner in banners" :key="banner.id">
			<div class="search-full__banner">
				<div class="typography" v-html="banner.Banner"></div>
			</div>
		</div>

		<div class="search-full__item-title" v-if="isSearching">Searching...</div>
		<div class="search-full__item" v-else-if="resultCount">
			<ul class="search-full__item-list">
				<li
					class="search-full__item-list-item"
					v-for="(row, rowIndex) in rows"
					:id="row.id"
				>
					<div class="search-full-item">
						<div class="search-full-item__grid">
							<div
								class="search-full-item__grid-item search-full-item__grid-item--header"
							>
								<div class="search-full-item__header">
									<h3
										class="search-full__item-list-title"
										v-text="row.title"
									></h3>
									<a
										class="search-full__item-list-link"
										:href="row.url"
										v-text="row.url"
									></a>
								</div>
							</div>

							<div
								class="search-full-item__grid-item search-full-item__grid-item--description"
							>
								<div class="search-full-item__desc">
									<div class="typography">
										<p v-text="row.description"></p>
									</div>
								</div>
							</div>

							<div
								class="search-full-item__grid-item search-full-item__grid-item--media"
							>
								<figure class="search-full-item__figure" v-if="row.image">
									<img
										class="search-full-item__image"
										:src="row.image"
										loading="lazy"
										width="300"
										height="200"
									/>
								</figure>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="search-full__item-title" v-else-if="data">No Results</div>
	</div>
</template>
